import { InputAdornment, TextFieldProps } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import { RedditTextField } from '@Components/Form/RedditTextField/RedditTextField'
import clsx from 'clsx'
import { makeStyles } from '@mui/styles'
import { $Gray75, $Gray77 } from '@Styles/colors'

const useStyles = makeStyles(() => ({
    root: {
        // height: 40,
        '& .MuiInputBase-root': {
            // height: 40,
        },
        '& .MuiInputAdornment-root': {
            margin: 'unset !important',
        },
        '& input': {
            padding: '14px 13px 13px !important',
            color: $Gray75,
            fontWeight: 'normal !important',
        },
    },
}))

const BaseSearch = (props: TextFieldProps) => {
    const classes = useStyles()

    return (
        <RedditTextField
            className={clsx('reddit-input w-100', classes.root)}
            variant="filled"
            startAdornment={
                <InputAdornment position="start" style={{ color: $Gray77 }}>
                    <SearchIcon />
                </InputAdornment>
            }
            {...props}
        />
    )
}

export default BaseSearch
